import { render, staticRenderFns } from "./ROITableVDP.vue?vue&type=template&id=00853433&scoped=true&"
import script from "./ROITableVDP.vue?vue&type=script&lang=js&"
export * from "./ROITableVDP.vue?vue&type=script&lang=js&"
import style0 from "./ROITableVDP.vue?vue&type=style&index=0&id=00853433&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00853433",
  null
  
)

export default component.exports